import styled, { css } from 'styled-components';
import { SlideUp } from 'styles/keyframes/SlideUp';
import specialityBg from 'assets/images/main/speciality_background.png';

export const Section = styled.section`
  padding: ${({ $background, $padding }) => ($background && `104px 0`) || ($padding && $padding) || `104px 24px`};
  max-width: ${({ $background, $width }) => ($background && `100vw`) || ($width && $width) || `1440px`};
  margin: auto;
  position: relative;
  ${({ $background, theme }) =>
    $background &&
    css`
      background-color: ${theme.colors.primary100};
      max-height: 759px;
      height: 100%;
    `};

  ${({ $background }) =>
    $background &&
    `
    &::before{
      content: "";
      position: absolute;
      top:0;
      display:block;
      width:100vw;
      max-height: 759px;
      height: 100%;
      background-image: url(${specialityBg});
      background-repeat: no-repeat;
      background-size: cover;
      background-position-y: bottom;
      background-position-x: center;
    }
    &::after{
      content: "";
      position: absolute;
      top:0;
      display:block;
      width:100vw;
      max-height: 759px;
      height: 100%;
      background-color:rgba(255, 255, 255, 0.33);
    }
   `}
  @media ${({ theme }) => theme.device.tablet} {
    padding: ${({ $padding, $tPadding }) => ($tPadding && `74px 0`) || ($padding && $padding) || `72px 24px`};
    max-width: ${({ $background, $width, $tWidth }) =>
      ($background && `100vw`) || ($width && $width) || ($tWidth && $tWidth) || `100%`};
    ${({ $background }) =>
      $background &&
      css`
        max-height: 719px;
      `};

    ${({ $background }) =>
      $background &&
      `
      &::before{
        max-height:719px;
      }
     `}
  }
  @media ${({ theme }) => theme.device.mobile} {
    padding: ${({ $mPadding }) => ($mPadding && $mPadding) || `48px 0`};
    ${({ $background }) =>
      $background &&
      css`
        max-height: 1080px;
      `};

    ${({ $background }) =>
      $background &&
      `
      &::before{
        max-height:1080px;
      }
     `}
  }
`;

export const AniBox = styled.div`
  opacity: ${({ $position }) => ($position && 1) || 0};
  animation: ${({ $position }) => $position && SlideUp};

  @media ${({ theme }) => theme.device.tablet} {
    opacity: ${({ $tPosition }) => ($tPosition && 1) || 0};
    animation: ${({ $tPosition }) => $tPosition && SlideUp};
  }
`;
